{{ runChangeDetection }}
<!--TODO https://ng.ant.design/components/segmented/en-->

<!--после выхода из свапа ребут компонентов проврка по посл время запроса-->
<ng-container *ngIf="(isLoaded$ | async) === false">
  <div class="load-messages">
    <div class="load-messages-wrap">
      <div class="dot-carousel d-flex justify-content-between"><i></i><i></i><i></i></div>
    </div>
  </div>
</ng-container>
<div
  [class.open-dropdown]="false && (interfaceService.openDropdown$ | async)?.component === 'chat-list'"
  #scrollable class="scroll-sidebar scroll-sidebar-chat">
  <div *ngIf="allService.token === allService.demoToken">
    <alert [type]="'primary'" class="alert-top">
      <div class="d-flex align-items-center w-100">
        <div class="icon-alert mr-4">
          <i-feather name="alert-triangle" class="text-warning"></i-feather>
        </div>
        <div>
          Демо аккаунт,
          <span (click)="logout()" class="text-primary pointer">авторизоваться</span>
        </div>
      </div>
    </alert>
  </div>
  <div
    *ngIf="allMessengersService.getConnectList()?.length > 0"
  >
    <alert [type]="'danger'" class="alert-top">
      <div class="d-flex align-items-center w-100">
        <div class="icon-alert mr-4">
          <i-feather name="alert-triangle" class="text-danger no-invert"></i-feather>
        </div>
        <p>
          Прервано соединение с сервером <span *ngIf="!interfaceService.isTelesellerDomain">{{ allMessengersService.getConnectList().join(', ') }}</span>.<br/>
          <ng-template [ngIf]="allMessengersService.getConnectList(true)?.length == 0" [ngIfElse]="inlineInternetText">
            <small>
              Убедитесь, что ваш <span class="d-none d-md-inline-block">компьютер</span
            ><span class="d-md-none">телефон</span> подключен к Интернету.

            Возможно это кратковременные технические работы. Идут попытки подключения...
            </small>
          </ng-template>
          <ng-template #inlineInternetText>
            Идут попытки подключения...
          </ng-template>
          Функционал рассылок должен работать.
        </p>
      </div>
    </alert>
  </div>
  <div class="container-fluid px-4 pb-6 h-100">

    <!-- Search -->
    <app-chat-search *ngIf="false" [Service]="Service"></app-chat-search>
    <!-- Search -->
    <app-online-slider *ngIf="!interfaceService.isTelesellerDomain" [Service]="Service" class="d-block"></app-online-slider>
    <app-error-show
      (onReload)="reload('button')"
      [Service]="Service"
      [error]="isLoadError$.value"
      *ngIf="(isLoadError$ | async) && arChat?.length === 0; else elseBlock"
      class="h-100"
    ></app-error-show>
    <ng-template #elseBlock>
      <!-- Chats -->
      <nav class="nav d-block list-discussions-js mb-n6 mt-5">
        <!-- Chat link -->
        <ng-template let-chat let-i="index" ngFor [ngForOf]="loadData">
          <div class="chat-channel mb-3 nav-link p-0 text-reset">
            <div class="card card-active-listener">
              <div class="card-body p-3">
                <div class="media">
                  <div class="avatar mr-5">
                    <div class="avatar-icon text-white" [ngStyle]="{ 'background-color': '#c4c4c4' }">
                      <div [ngSwitch]="type" class="d-flex w-100 align-items-center justify-content-center">
                        <i-feather name="message-square" class="icon-md"></i-feather>
                      </div>
                    </div>
                  </div>
                  <div class="media-body overflow-hidden">
                    <div class="d-flex align-items-center justify-content-between mb-1">
                      <nz-skeleton-element
                        [style.width.px]="chat.title_width || 130"
                        nzType="input"
                        [nzActive]="true"
                        [nzSize]="'small'"
                      ></nz-skeleton-element>
                      <nz-skeleton-element
                        [style.width.px]="50"
                        nzType="input"
                        [nzActive]="true"
                        [nzSize]="'small'"
                      ></nz-skeleton-element>
                    </div>
                    <nz-skeleton-element
                      [style.width.px]="(chat.title_width || 130) - 50"
                      nzType="input"
                      [nzActive]="true"
                      [nzSize]="'small'"
                    ></nz-skeleton-element>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template let-chat let-i="index" ngFor [ngForOf]="arChat" [ngForTrackBy]="trackByFn">
          <ng-template [ngIf]="i < showCount$.value">
            <app-chat-item [contextMenu]="contextMenu" [chat]="chat" [Service]="Service"></app-chat-item>
          </ng-template>
        </ng-template>
        <!--<div class="text-center pt-3 pb-5" *ngIf="Service?.arChat && Service?.arChat?.length > showCount">
                  <button class="btn btn-outline-primary btn-sm" (click)="showAdd()">
                    Показать еще {{showCount}}/{{Service.arChat?.length}}
                  </button>
                </div>-->

        <!-- Chat link -->
      </nav>

      <!--<div (deferVizible)="lazyLoad($event)"></div>-->
    </ng-template>
  </div>
</div>
<!-- Chats -->
<div class="py-1 sidebar-footer">
  <div class="container-fluid">
    <!--<app-chat-list-filter [class.loaded]="isLoaded$ | async" (setFilter)="setFilter($event)"></app-chat-list-filter>-->
    <div class="row justify-content-between">
      <!--<div class="col-auto px-0">
        <button (click)="onlyUnreadToggle()" class="nav-link btn btn-sm">
          <i-feather [name]="onlyUnread ? 'eye' : 'eye-off'" class="icon-md"></i-feather>
          {{onlyUnread ? 'Показать все' : 'Непрочитанные'}}
        </button>
      </div>-->
      <div *ngIf="!interfaceService.isTelesellerDomain" class="col-auto px-0">
        <button
          [class.disable-swich]="allService.serviceType === 'all' && !this.allService._openChatId"
          (click)="showMobileHome()"
          class="nav-link btn btn-sm position-relative"
          placement="left"
          tooltip="Домой"
        >
          <i-feather name="home" class="icon-md"></i-feather>
        </button>
      </div>
    </div>
  </div>
</div>

<context-menu (open)="interfaceService.contextMenuOpenEvent($event, 'chat-list')"
              (close)="interfaceService.contextMenuCloseEvent($event)">
  <ng-template [visible]="isChatPinned" contextMenuItem let-item (execute)="toggleChatPine($event.item)">
    Открепить&nbsp;<i-feather name="paperclip" class="ml-auto float-right"></i-feather>
  </ng-template>
  <ng-template
    disabled="true"
    [visible]="isNotChatPinned"
    contextMenuItem
    let-item
    (execute)="toggleChatPine($event.item)"
  >
    Закрепить&nbsp;<i-feather name="paperclip" class="ml-auto float-right"></i-feather>
  </ng-template>
  <ng-template contextMenuItem let-item (execute)="openProfile($event.item)">
    Показать профиль&nbsp;<i-feather name="user" class="ml-auto float-right"></i-feather>
  </ng-template>
  <ng-template
    [visible]="isNotificationsSupport"
    contextMenuItem
    let-item
    (execute)="
      modalService.openModal('ModalNotifySettingsComponent', {
        Service: Service,
        chat: $event.item
      })
    "
  >
    Настроить уведомления&nbsp;<i-feather name="bell" class="ml-auto float-right"></i-feather>
  </ng-template>
  <ng-template [visible]="isUnread" contextMenuItem let-item (execute)="readHistory($event.item)">
    Пометить как прочитанное&nbsp;<i-feather name="message-square" class="ml-auto float-right"></i-feather>
  </ng-template>
  <ng-template
    [visible]="isInvite"
    contextMenuItem
    let-item
    (execute)="openAddChatMember($event.item)"
  >
    Пригласить собеседника&nbsp;<i-feather name="user-plus" class="ml-auto float-right"></i-feather>
  </ng-template>
  <ng-template
    [visible]="isLeave"
    contextMenuItem
    let-item
    (execute)="allMessengersService.leaveChat($event.item, false, Service).subscribe()"
  >
    Покинуть чат&nbsp;<i-feather name="log-out" class="ml-auto float-right"></i-feather>
  </ng-template>

  <ng-template contextMenuItem divider="true"></ng-template>
  <ng-template contextMenuItem let-item (execute)="allMessengersService.leaveChat($event.item, true, Service).subscribe()">
    Удалить чат&nbsp;<i-feather name="trash-2" class="ml-auto text-danger float-right"></i-feather>
  </ng-template>
</context-menu>
